import React, {useContext} from "react";
import GlobalContext from "../GlobalContext";
import moment from "moment";

const TableCell = ({dayNumber, dayType, monthType}) => {

  const CONTEXT = useContext(GlobalContext);

  function handleClick(dayType, dayNumber, setSelectedDay) {
    if (dayType !== "normal" && setSelectedDay) {
      setSelectedDay(dayNumber);
    }
  }

  function dayTypeBackgroundClass(dayType) {
    switch (dayType) {
      case 'periodical_report':
        return "color-background-red";
      case 'closed_period':
        return "color-background-gray";
      case 'corporate_event':
        return "color-background-orange";
      default:
        return "";
    }
  }

  function generateClasses(monthType) {
    let defaultClasses = 'text-center p-1';
    let additionalClasses = "";
    let stylingClasses = "";

    if (["previous", "next"].includes(monthType)) {
      additionalClasses = " text-muted ";
    }

    if (monthType === "current" && moment().date() === dayNumber && CONTEXT.selectedYear === moment().year()) {
      additionalClasses = " font-weight-bold text-underline ";
    }

    if (dayType !== "normal") {
      additionalClasses += " cursor-pointer ";
      stylingClasses = " color-text-white ";
    }

    stylingClasses += ` ${dayTypeBackgroundClass(dayType)} `;

    return [defaultClasses, additionalClasses, stylingClasses].join(" ").trim().replace(/\s+/g, ' ');
  }

  function eventTypeColorValue(eventType) {
    switch(eventType) {
      case 'periodical_report':
        return '#b50043';
      case 'closed_period':
        return '#adb5bd';
      case 'corporate_event':
        return '#fc9200'
    }
  }

  // for more than 1 event
  function dayTypeBackground(dayType) {
    return `linear-gradient(to bottom right, ${eventTypeColorValue(dayType[0])} 50%, ${eventTypeColorValue(dayType[1])} 50%)`;
  }

  return (
    <GlobalContext.Consumer>
      {({
          setSelectedDay
        }) => (
        <td
          className={generateClasses(monthType)}
          data-day-number={dayNumber}
          data-day-type={dayType}
          data-month-type={monthType}
          style={Array.isArray(dayType) ? {background: dayTypeBackground(dayType), width: '14.285714286%' } : {width: '14.285714286%'}}
          onClick={() => handleClick(dayType, dayNumber, setSelectedDay)}
        >
          {dayNumber}
        </td>
      )}
    </GlobalContext.Consumer>
  );
};

export default TableCell;
